import { useMemo } from "react";

import { pickBy } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import FORMATIVE_GRAPHIC_ORGANIZERS from "@/view/constants/formativeGraphicOrganizers";
import useReadingSkillsContext from "@/view/utils/useReadingSkillsContext/useReadingSkillsContext";
import GraphicOrganizerModal from "../../GraphicOrganizerModal";
import {
  containerCss,
  unorderedListCss,
} from "./GraphicOrganizerContainer.style";

const propTypes = {
  contentId: PropTypes.string,
  metadata: PropTypes.array,
  userProperties: PropTypes.object,
};

const GraphicOrganizerContainer = ({ contentId, userProperties }) => {
  const { readingSkillState } = useReadingSkillsContext();

  const { isAuthorizedTeacher, canSeeAiFeatures } = userProperties;

  const selectedReadingSkills = {
    ...pickBy(
      readingSkillState,
      (item) => item.isReadingSkillSelected === true,
    ),
  };
  const readingSkillTitles = Object.keys(selectedReadingSkills);

  const matchReadingSkillstoOrganizers = useMemo(
    () =>
      readingSkillTitles.map((title) => {
        const relevantOrganizers = FORMATIVE_GRAPHIC_ORGANIZERS.filter(
          (organizer) => {
            return (
              organizer["Reading Skill"].toLowerCase() === title.toLowerCase()
            );
          },
        );

        return {
          title,
          graphicOrganizers: relevantOrganizers,
        };
      }),
    [
      JSON.stringify(readingSkillState),
      JSON.stringify(FORMATIVE_GRAPHIC_ORGANIZERS),
    ],
  );

  const readingSkillsWithGraphicOrganizers = (
    matchReadingSkillstoOrganizers ?? []
  ).filter((readingSkill) => {
    return readingSkill.graphicOrganizers?.length > 0;
  });

  if (
    !isAuthorizedTeacher ||
    !canSeeAiFeatures ||
    !readingSkillsWithGraphicOrganizers.length
  )
    return null;

  return (
    <div css={containerCss}>
      <ul css={unorderedListCss}>
        {readingSkillsWithGraphicOrganizers.map((readingSkill) => {
          return (
            <li key={`${readingSkill?.title}-modal-button`}>
              <GraphicOrganizerModal
                contentId={contentId}
                graphicOrganizers={readingSkill.graphicOrganizers}
                title={readingSkill.title}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

GraphicOrganizerContainer.propTypes = propTypes;
export default GraphicOrganizerContainer;
